import { render, staticRenderFns } from "./dashboardsg.vue?vue&type=template&id=dcd5dfb6&"
import script from "./dashboardsg.vue?vue&type=script&lang=js&"
export * from "./dashboardsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports